var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { ref: "searchbox", on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              {
                staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3",
              },
              [
                _c("c-plant", {
                  attrs: { type: "search", name: "plantCd" },
                  on: { datachange: _vm.getList },
                  model: {
                    value: _vm.searchParam.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "plantCd", $$v)
                    },
                    expression: "searchParam.plantCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3",
              },
              [
                _c("c-text", {
                  attrs: {
                    label: "자재명",
                    name: "materialName",
                    placeholder: "자재명",
                  },
                  on: { datachange: _vm.getList },
                  model: {
                    value: _vm.searchParam.materialName,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "materialName", $$v)
                    },
                    expression: "searchParam.materialName",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3",
              },
              [
                _c("c-text", {
                  attrs: {
                    label: "CAS.No",
                    name: "casNo",
                    placeholder: "CAS.No",
                  },
                  on: { datachange: _vm.getList },
                  model: {
                    value: _vm.searchParam.casNo,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "casNo", $$v)
                    },
                    expression: "searchParam.casNo",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3",
              },
              [
                _c("c-text", {
                  attrs: { label: "KE.No", name: "keNo", placeholder: "KE.No" },
                  on: { datachange: _vm.getList },
                  model: {
                    value: _vm.searchParam.keNo,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "keNo", $$v)
                    },
                    expression: "searchParam.keNo",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-table",
        {
          ref: "materialTable",
          attrs: {
            title: "자재 목록",
            columns: _vm.grid.columns,
            data: _vm.grid.data,
            gridHeight: _vm.grid.height,
            selection: _vm.popupParam.type,
            rowKey: "materialCd",
          },
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _c("c-btn", {
                    attrs: { label: "선택", icon: "check" },
                    on: { btnClicked: _vm.select },
                  }),
                  _c("c-btn", {
                    attrs: { label: "검색", icon: "search" },
                    on: { btnClicked: _vm.getList },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }